import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * AdminBreadcrumb component for consistent navigation breadcrumbs
 * in admin pages.
 *
 * Root is always a ← arrow that navigates to /admin (→ /dashboard).
 * Shows current page label only.
 */
const AdminBreadcrumb = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbMap = {
    'dashboard': t('dashboard.title'),
    'data-grid': t('nav.dataGrid'),
    'admin': '',
    'create-property': t('admin.title'),
    'property-manager': 'Quản lý nhà trọ',
    'calendar': t('calendar.title'),
    'university': t('university.title'),
    'address': t('address.title') || 'Tìm theo địa chỉ',
    'user-bookings': 'Đặt lịch xem nhà',
    'session-manager': t('session.pageTitle'),
  };

  // Find current page label
  const getCurrentLabel = () => {
    if (pathnames.length === 0) return null;
    
    // /admin/create-property → take the last segment
    const lastSegment = pathnames[pathnames.length - 1];
    return breadcrumbMap[lastSegment] || lastSegment;
  };

  const currentLabel = getCurrentLabel();

  return (
    <nav className="flex items-center text-sm mb-6">
      <Link
        to="/admin"
        className="text-gray-500 hover:text-primary-600 transition-colors flex items-center gap-1"
        title={t('dashboard.title')}
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
      </Link>
      
      {currentLabel && (
        <>
          <span className="text-gray-400 mx-2">/</span>
          <span className="text-gray-900 font-medium">{currentLabel}</span>
        </>
      )}
    </nav>
  );
};

export default AdminBreadcrumb;